module.exports = __webpack_public_path__ + "static/media/cases_web_keslon_07a.3128e1e9.jpg";